import { findLastIndex } from 'lodash';

import { IconColor } from '../../types/IconColor';
import { IconType } from '../../types/IconType';
import { SharedIconProps } from '../../types/SharedIconProps';
import { StatusType } from '../../types/StatusType';
import { Step } from './types';

interface IconProps {
  color: IconColor;
  icon: IconType;
  size: SharedIconProps['size'];
}

interface Props {
  isCurrent: boolean;
  isDarkTheme: boolean;
  isSectionsMode: boolean;
  step: Step;
}

export const getCompletedCount = (steps: Step[]): number => {
  return steps.filter((step) => step.isCompleted).length;
};

export const getIconProps = ({
  isCurrent,
  isDarkTheme,
  isSectionsMode,
  step,
}: Props): IconProps => {
  const { error, isCompleted, isOptional, isLoading } = step;

  let color: IconColor;
  let icon: IconType;

  // order matters
  if (error) {
    color = 'status.danger';
    icon = 'status-danger';
  } else if (isCompleted) {
    color = isDarkTheme && !isSectionsMode ? 'status.success' : 'status.active';
    icon = 'status-success';
  } else if (isOptional) {
    color = isCurrent ? 'status.active' : 'status.inactive';
    icon = isCurrent ? 'status-current' : 'status-optional';
  } else if (isLoading) {
    color = 'inherit';
    icon = 'loading';
  } else {
    color = isCurrent ? 'status.active' : 'status.info';
    icon = isCurrent ? 'status-current' : 'status-not-started';
  }

  return { color, icon, size: isSectionsMode ? 'm' : 'ml' };
};

export const getStepStatus = ({
  isCurrent,
  step,
}: {
  isCurrent: boolean;
  step: Step;
}): StatusType | undefined => {
  const { error, isCompleted } = step;
  if (error) {
    return 'danger';
  }
  if (isCompleted) {
    return 'success';
  }
  if (isCurrent) {
    return undefined;
  }
  return 'info';
};

export const findLastCompletedIndex = (steps: Step[]): number => {
  return findLastIndex(steps, ['isCompleted', true]);
};
